import React from 'react'
import { Tooltip, Typography, message } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'

const { Text } = Typography

const InfoRow = ({ icon, label, value, copyable = false, token }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '12px 0',
      borderBottom: `1px solid ${token.colorBorderSecondary}`
    }}
  >
    <div
      style={{
        minWidth: '24px',
        marginRight: '12px',
        color: token.colorPrimary
      }}
    >
      <FontAwesomeIcon icon={icon} />
    </div>
    <div style={{ minWidth: '120px', marginRight: '16px' }}>
      <Text strong style={{ color: token.colorTextSecondary, fontSize: '14px' }}>
        {label}:
      </Text>
    </div>
    <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
      <Text style={{ fontSize: '14px', color: token.colorText }}>{value}</Text>
      {copyable && (
        <Tooltip title='Copy to clipboard'>
          <FontAwesomeIcon
            icon={faCopy}
            style={{
              cursor: 'pointer',
              marginLeft: '8px',
              color: token.colorPrimary,
              fontSize: '12px'
            }}
            onClick={(e) => {
              e.stopPropagation()
              navigator.clipboard.writeText(value)
              message.success('Copied to clipboard')
            }}
          />
        </Tooltip>
      )}
    </div>
  </div>
)

export default InfoRow
